// Utility for subscription status checking
/**
 * Utility to check subscription status from various sources
 */

/**
 * Checks if there is any active subscription (local or otherwise)
 */
export const hasAnyActiveSubscription = async (): Promise<boolean> => {
    try {
        // Check local storage for guest subscription status
        const localStatus = localStorage.getItem('subscriptionStatus');
        if (localStatus === 'active') {
            return true;
        }

        return false;
    } catch (error) {
        console.error('Error checking active subscription:', error);
        return false;
    }
};

/**
 * Gets the current subscription status string
 */
export const getSubscriptionStatus = async (): Promise<string> => {
    try {
        const localStatus = localStorage.getItem('subscriptionStatus');
        return localStatus || 'inactive';
    } catch (error) {
        console.error('Error getting subscription status:', error);
        return 'inactive';
    }
};
